import React from 'react'
import PropTypes from 'prop-types'
import { useD3Selection } from 'src/hooks'

function Point({ point, className, color, symbol }) {
  const [ref, useSelectionEffect] = useD3Selection()

  useSelectionEffect(
    selection => {
      selection.attr('d', symbol).attr('transform', `translate(${point.x},${point.y}) rotate(45)`)
    },
    [point]
  )

  return <path ref={ref} fill={color} className={className} stroke="white" strokeWidth={1.5} />
}

Point.propTypes = {
  point: PropTypes.object,
  className: PropTypes.string,
  color: PropTypes.string,
  symbol: PropTypes.func,
}

export default React.memo(Point)
